import React, { useState } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import * as yup from 'yup'
import { Formik } from 'formik'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import CustomButton from '../../shared/button/Button'
import Toast from 'react-native-toast-message'

const OkInformationForm = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const { loading, postokonline } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()

    const intialValues = {
        Filing_status: '',
        allowanceforyourself: '',
        allowanceforspouse: null,
        allowancefordependents: '',
        additionalallowances: '',
        additionalwitholdingperpayperiod: '',
        exemptstatus: '',
        oklahoma_tax_exempt_status: '',
        is_military_income_exempt: '',
        exemptionGroup: ''
    }

    const options1 = [
        { key: 1, value: 'Single' },
        { key: 2, value: 'Married' },
        { key: 3, value: 'Married, but withhold at higher Single rate' }
    ]


    const options4 = [
        { key: 1, value: 'Yes' },
        { key: 2, value: 'No' }
    ]

    const okschema = yup.object({
        Filing_status: yup.string().required('Filing Status is a required field'),
        allowanceforyourself: yup
            .string()
            .matches(/^1$/, "Enter '1' or leave it empty")
            .nullable(),
        allowanceforspouse: yup
            .string()
            .when('Filing_status', (Filing_status: any, schema) => {
                if (Filing_status == 1 || Filing_status == 2) {
                    return schema.required('Does your spouse work is a required field')
                }
                return schema.nullable()
            }),
        allowancefordependents: yup.string().nullable(),
        additionalallowances: yup.string().nullable(),
        additionalwitholdingperpayperiod: yup.string().nullable(),
        exemptstatus: yup
            .string()
            .matches(/^exempt$/i, "Enter 'Exempt' or leave it empty")
            .nullable(),
        oklahoma_tax_exempt_status: yup
            .string()
            .matches(/^exempt$/i, "Enter 'Exempt' or leave it empty")
            .nullable(),
        is_military_income_exempt: yup
            .string()
            .matches(/^exempt$/i, "Enter 'Exempt' or leave it empty")
            .nullable(),

        exemptionGroup: yup
            .mixed()
            .test(
                'only-one-exempt',
                'Only one of the exemption fields can be filled with "Exempt", or all must be empty.',
                function (_, context) {
                    const {
                        exemptstatus,
                        oklahoma_tax_exempt_status,
                        is_military_income_exempt
                    } = context.parent
                    const values = [
                        exemptstatus,
                        oklahoma_tax_exempt_status,
                        is_military_income_exempt
                    ]
                    const filledCount = values.filter(
                        (v) => v && /^exempt$/i.test(v)
                    ).length
                    return filledCount === 0 || filledCount === 1
                }
            )
    })

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'OK Withholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={okschema}
                    onSubmit={async (values, actions) => {
                        const total =
                            Number(values?.allowanceforyourself) +
                            Number(values?.allowanceforspouse) +
                            Number(values?.allowancefordependents) +
                            Number(values?.additionalallowances)
                        const data = {
                            entityId: personalstore.personalData?.entityId,
                            essUserKey: initializestore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            completeOnline: mode === 'upload' ? false : true,
                            filingStatus: values?.Filing_status,
                            allowanceForYourself: values?.allowanceforyourself
                                ? values?.allowanceforyourself
                                : null,
                            allowanceForYourSpouse: values?.allowanceforspouse ?? null,
                            allowanceForDependents: values?.allowancefordependents
                                ? values?.allowancefordependents
                                : 0,
                            totalNumberOfAllowances: total,
                            additionalWithholdingPerPayPeriod:
                                values?.additionalwitholdingperpayperiod
                                    ? values?.additionalwitholdingperpayperiod
                                    : null,
                            exemptStatus: values?.exemptstatus
                                ? values?.exemptstatus?.toUpperCase()
                                : null,
                            oklahomaTaxExemptStatus: values?.oklahoma_tax_exempt_status
                                ? values?.oklahoma_tax_exempt_status?.toUpperCase()
                                : null,
                            isMilitaryIncomeExempt: values?.is_military_income_exempt
                                ? values?.is_military_income_exempt?.toUpperCase()
                                : null,
                            additionalAllowances: values?.additionalallowances
                                ? values?.additionalallowances
                                : null
                        }

                        const response = await postokonline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('OkInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,
                                    total
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }
                    }}
                >
                    {(props) => {
                        const isExempt =
                            props.values.exemptstatus?.toLowerCase() === 'exempt' ||
                            props.values.oklahoma_tax_exempt_status?.toLowerCase() === 'exempt' ||
                            props.values.is_military_income_exempt?.toLowerCase() === 'exempt'

                        return (
                            <>
                                <Card>
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Filing status *'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <SelectKeyValue
                                                title="Filing status"
                                                options={options1}
                                                selectedOption={mapSelectValue(
                                                    options1,
                                                    props.values.Filing_status
                                                )}
                                                onSelect={(option: any) => {
                                                    if (option - 1 == 0) {
                                                        props.setFieldValue('Filing_status', option - 1)
                                                        props.setFieldValue('allowanceforspouse', null)
                                                    }
                                                    props.setFieldValue('Filing_status', option - 1)
                                                }}
                                                textColor="primary"
                                            />
                                            {props.touched.Filing_status &&
                                                props.errors.Filing_status && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.Filing_status}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Allowance For Yourself: Enter 1 for yourself'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.allowanceforyourself}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('allowanceforyourself')(text)
                                                    }
                                                }}
                                            />

                                            {props.touched.allowanceforyourself &&
                                                props.errors.allowanceforyourself && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.allowanceforyourself as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>

                                    {(Number(props.values.Filing_status) == 1 ||
                                        Number(props.values.Filing_status) == 2) && (
                                            <View
                                                style={[
                                                    globalStyles.hDirection,
                                                    globalStyles.hBetweenItems,
                                                    globalStyles.mb2
                                                ]}
                                            >
                                                <View style={{ justifyContent: 'center', width: '50%' }}>
                                                    <Text
                                                        style={[
                                                            globalStyles.inputLabel,
                                                            globalStyles.inputLabelLarge,
                                                            globalStyles.inputLabelPrimary
                                                        ]}
                                                    >
                                                        {'Does your spouse work? *'}
                                                    </Text>
                                                </View>
                                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                                    <SelectKeyValue
                                                        title="Does your spouse work?"
                                                        options={options4}
                                                        selectedOption={mapSelectValue(
                                                            options4,
                                                            props.values.allowanceforspouse
                                                        )}
                                                        onSelect={(option: any) => {
                                                            props.setFieldValue('allowanceforspouse', option - 1)
                                                        }}
                                                        textColor="primary"
                                                    />
                                                    {props.touched.allowanceforspouse &&
                                                        props.errors.allowanceforspouse && (
                                                            <Text style={globalStyles.dangerAlert}>
                                                                {props.errors.allowanceforspouse as string}
                                                            </Text>
                                                        )}
                                                </View>
                                            </View>
                                        )}

                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'Enter the number of dependents you will claim on your tax return. Do not claim yourself or your spouse or dependents that your spouse has already claimed on his or her Form OK-W-4'
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.allowancefordependents}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('allowancefordependents')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.allowancefordependents &&
                                                props.errors.allowancefordependents && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.allowancefordependents as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'Enter the number of additional allowances you would like to claim '
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.additionalallowances}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('additionalallowances')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.additionalallowances &&
                                                props.errors.additionalallowances && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.additionalallowances}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                    {!isExempt && (
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ justifyContent: 'center', width: '50%' }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {
                                                        'Enter the additional amount to be withheld each pay period '
                                                    }
                                                </Text>
                                            </View>
                                            <View style={{ width: '28%', overflow: 'hidden' }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.additionalwitholdingperpayperiod}
                                                    keyboardType="numeric"
                                                    onChangeText={(text) => {
                                                        if (text === '' || /^\d+$/.test(text)) {
                                                            props.handleChange(
                                                                'additionalwitholdingperpayperiod'
                                                            )(text)
                                                        }
                                                    }}
                                                />
                                                {props.touched.additionalwitholdingperpayperiod &&
                                                    props.errors.additionalwitholdingperpayperiod && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.additionalwitholdingperpayperiod}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                    )}

                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'If you had a right to a refund of all of your Oklahoma income tax withheld last year because you had no tax liability and this year you expect a refund of all Oklahoma income tax withheld because you expect to have no tax liability.Write “Exempt”'
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.exemptstatus}
                                                onChangeText={(text) => {
                                                    props.handleChange('exemptstatus')(text)
                                                    if (text?.toLowerCase() === 'exempt') {
                                                        props.setFieldValue('additionalwitholdingperpayperiod', '')
                                                    }
                                                }}
                                            />

                                            {props.touched.exemptstatus &&
                                                props.errors.exemptstatus && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.exemptstatus}
                                                    </Text>
                                                )}
                                            {props.errors.exemptionGroup && (
                                                <Text style={{ color: 'red', marginTop: 5 }}>
                                                    {props.errors.exemptionGroup}
                                                </Text>
                                            )}
                                        </View>
                                    </View>
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'If you meet the conditions set forth under the Servicemember Civil Relief Act, as amended by the Military Spouses Residency Relief Act and have no Oklahoma tax liability, Write “Exempt”'
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.oklahoma_tax_exempt_status}
                                                onChangeText={(text) => {
                                                    props.handleChange('oklahoma_tax_exempt_status')(text)
                                                    if (text?.toLowerCase() === 'exempt') {
                                                        props.setFieldValue('additionalwitholdingperpayperiod', '')
                                                    }
                                                }}
                                            />
                                            {props.touched.oklahoma_tax_exempt_status &&
                                                props.errors.oklahoma_tax_exempt_status && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.oklahoma_tax_exempt_status}
                                                    </Text>
                                                )}

                                            {props.errors.exemptionGroup && (
                                                <Text style={{ color: 'red', marginTop: 5 }}>
                                                    {props.errors.exemptionGroup}
                                                </Text>
                                            )}
                                        </View>
                                    </View>
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'If income earned as a member of any active duty component of the Armed Forces of the United State is eligible for the military income deduction Write “Exempt”'
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.is_military_income_exempt}
                                                onChangeText={(text) => {
                                                    props.handleChange('is_military_income_exempt')(text)
                                                    if (text?.toLowerCase() === 'exempt') {
                                                        props.setFieldValue('additionalwitholdingperpayperiod', '')
                                                    }
                                                }}
                                            />
                                            {props.touched.is_military_income_exempt &&
                                                props.errors.is_military_income_exempt && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.is_military_income_exempt}
                                                    </Text>
                                                )}
                                            {props.errors.exemptionGroup && (
                                                <Text style={{ color: 'red', marginTop: 5 }}>
                                                    {props.errors.exemptionGroup}
                                                </Text>
                                            )}
                                        </View>
                                    </View>
                                    {loading ? (
                                        <ActivityIndicator />
                                    ) : (
                                        <View style={{ margin: 10 }}>
                                            <CustomButton
                                                text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                                onPress={props.handleSubmit}
                                            />
                                        </View>
                                    )}
                                </Card>
                            </>
                        )
                    }}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default OkInformationForm
